module.exports = __webpack_public_path__ + "static/media/choose-type-modal4.f42393bc.svg";